<template>
  <el-dialog title="KPI选择" :visible.sync="visible" width="80%">
    <el-row type="flex" justify="center" align="center">
      <el-transfer v-model="selectedValue" :data="data" filterable :titles="['可选KPI', '已选KPI']" @change="changeHandleChange"></el-transfer>
    </el-row>
    <el-row type="flex" justify="end" align="center">
      <el-button style="margin-top:10px" type="primary" @click="handleChange()">确 定</el-button>
    </el-row>
  </el-dialog>
</template>
<script>
export default {
  name: 'chooseKpi',
  data () {
    return {
      key: '',
      type: '',
      visible: false,
      data: [],
      selectedValue: [],
      selectedValueQ1: [],
      selectedValueQ2: [],
      selectedValueQ3: [],
      selectedValueQ4: [],
      selectedValueQ5: [], // 年度考核
      selectedValueA1: [],
      selectedValueA2: [],
      selectedValueA3: [],
      selectedValueA4: [],
      selectedValueA5: [], // 年度考核
      selectedValueAllQ1: [],
      selectedValueAllQ2: [],
      selectedValueAllQ3: [],
      selectedValueAllQ4: [],
      selectedValueAllQ5: [], // 年度考核
      selectedValueAllA1: [],
      selectedValueAllA2: [],
      selectedValueAllA3: [],
      selectedValueAllA4: [],
      selectedValueAllA5: [], // 年度考核
      selectedData: [],
      quarterFlag: ''
    }
  },
  created () {},
  mounted () {},
  methods: {
    // 添加KPI
    add (index, type, channelId, year) {
      this.visible = true
      this.quarterFlag = index
      this.getKpiList(type, channelId, year)
      if (index === 'C0') {
        this.selectedValue = this.selectedValueQ1
      } else if (index === 'C1') {
        this.selectedValue = this.selectedValueQ2
      } else if (index === 'C2') {
        this.selectedValue = this.selectedValueQ3
      } else if (index === 'C3') {
        this.selectedValue = this.selectedValueQ4
      } else if (index === 'C4') {
        this.selectedValue = this.selectedValueQ5
      } else if (index === 'A0') {
        this.selectedValue = this.selectedValueA1
      } else if (index === 'A1') {
        this.selectedValue = this.selectedValueA2
      } else if (index === 'A2') {
        this.selectedValue = this.selectedValueA3
      } else if (index === 'A3') {
        this.selectedValue = this.selectedValueA4
      } else if (index === 'A4') {
        this.selectedValue = this.selectedValueA5
      }
    },
    // 选择KPI
    handleChange () {
      if (this.quarterFlag === 'C0') {
        this.selectedValueAllQ1 = []
        this.selectedValueQ1 = this.selectedValue
      } else if (this.quarterFlag === 'C1') {
        this.selectedValueAllQ2 = []
        this.selectedValueQ2 = this.selectedValue
      } else if (this.quarterFlag === 'C2') {
        this.selectedValueAllQ3 = []
        this.selectedValueQ3 = this.selectedValue
      } else if (this.quarterFlag === 'C3') {
        this.selectedValueAllQ4 = []
        this.selectedValueQ4 = this.selectedValue
      } else if (this.quarterFlag === 'C4') {
        this.selectedValueAllQ5 = []
        this.selectedValueQ5 = this.selectedValue
      } else if (this.quarterFlag === 'A0') {
        this.selectedValueAllA1 = []
        this.selectedValueA1 = this.selectedValue
      } else if (this.quarterFlag === 'A1') {
        this.selectedValueAllA2 = []
        this.selectedValueA2 = this.selectedValue
      } else if (this.quarterFlag === 'A2') {
        this.selectedValueAllA3 = []
        this.selectedValueA3 = this.selectedValue
      } else if (this.quarterFlag === 'A3') {
        this.selectedValueAllA4 = []
        this.selectedValueA4 = this.selectedValue
      } else if (this.quarterFlag === 'A4') {
        this.selectedValueAllA5 = []
        this.selectedValueA5 = this.selectedValue
      }
      this.visible = false
    },
    // 调用KPI--根据KPI类型筛选
    getKpiList (type, channelId, year) {
      // console.log(type)
      this.data = []
      this.$http.get(this.API.kpiQueryByChannelId, { params: { channelId: channelId, year: year } }).then((res) => {
        let data = res.data
        if (data.code === 200) {
          let arr = data.data.filter((ele) => {
            return ele.kpiType === type
          })
          let arr1 = []
          arr.forEach((ele, index) => {
            arr1.push({
              key: ele.kpiNm,
              label: ele.kpiNm
            // disabled: true
            })
          })
          this.data = arr1
        }
      })
    },
    // 数组对象去重---没用到
    deWeight (arr) {
      let result = []
      let obj = {}
      for (var i = 0; i < arr.length; i++) {
        if (!obj[arr[i].kpiNm]) {
          result.push(arr[i])
          obj[arr[i].kpiNm] = true
        }
      }
      return result
    },
    // 判断跳转直接合并-参数
    concat () {
      this.selectedData = []
      this.selectedValueQ1.forEach((ele) => {
        this.selectedValueAllQ1.push({
          quarter: 'Q1',
          kpiType: '季度考核',
          kpiName: ele
        })
      })
      this.selectedValueQ2.forEach((ele) => {
        this.selectedValueAllQ2.push({
          quarter: 'Q2',
          kpiType: '季度考核',
          kpiName: ele
        })
      })
      this.selectedValueQ3.forEach((ele) => {
        this.selectedValueAllQ3.push({
          quarter: 'Q3',
          kpiType: '季度考核',
          kpiName: ele
        })
      })
      this.selectedValueQ4.forEach((ele) => {
        this.selectedValueAllQ4.push({
          quarter: 'Q4',
          kpiType: '季度考核',
          kpiName: ele
        })
      })
      this.selectedValueQ5.forEach((ele) => {
        this.selectedValueAllQ5.push({
          quarter: 'Yearly',
          kpiType: '年度考核',
          kpiName: ele
        })
      })
      this.selectedValueA1.forEach((ele) => {
        this.selectedValueAllA1.push({
          quarter: 'Q1',
          kpiType: '附加',
          kpiName: ele
        })
      })
      this.selectedValueA2.forEach((ele) => {
        this.selectedValueAllA2.push({
          quarter: 'Q2',
          kpiType: '附加',
          kpiName: ele
        })
      })
      this.selectedValueA3.forEach((ele) => {
        this.selectedValueAllA3.push({
          quarter: 'Q3',
          kpiType: '附加',
          kpiName: ele
        })
      })
      this.selectedValueA4.forEach((ele) => {
        this.selectedValueAllA4.push({
          quarter: 'Q4',
          kpiType: '附加',
          kpiName: ele
        })
      })
      this.selectedValueA5.forEach((ele) => {
        this.selectedValueAllA5.push({
          quarter: 'Yearly',
          kpiType: '附加',
          kpiName: ele
        })
      })
      this.selectedData = this.selectedValueAllQ1
        .concat(this.selectedValueAllQ2)
        .concat(this.selectedValueAllQ3)
        .concat(this.selectedValueAllQ4)
        .concat(this.selectedValueAllQ5)
        .concat(this.selectedValueAllA1)
        .concat(this.selectedValueAllA2)
        .concat(this.selectedValueAllA3)
        .concat(this.selectedValueAllA4)
        .concat(this.selectedValueAllA5)
      console.log(this.selectedData)
    },
    changeHandleChange () {}
  }
}
</script>

<style lang="less" scoped>
.el-select {
  width: 100% !important;
}
</style>
